import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import HeroImg from "../../../assets/hero.webp";
import Circle from "../../../assets/circle.png";
import Button from "../../Utilities/Button";
import DownView from "../../Utilities/DownView";
import BottomRight from "../../../assets/bottom-right.png";
import { useNavigate } from "react-router-dom";
const Hero = () => {
  const navigate = useNavigate();
  const heroRef = useRef();
  const textRef = useRef();
  const lineRef = useRef();
  const workRef = useRef();
  useEffect(() => {
    gsap.fromTo(
      heroRef.current,
      {
        x: -200,
        opacity: 0,
        delay: 1.5,
      },
      {
        x: 0,
        opacity: 0.7,
        duration: 3,
      },
    );
    gsap.fromTo(
      textRef.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 2,
        delay: 1.5,
      },
    );
    gsap.from(lineRef.current, {
      width: "0%",
      duration: 1,
      delay: 2,
    });
    gsap.fromTo(
      workRef.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 1,
        delay: 2.5,
      },
    );
  }, []);
  return (
    <div className="relative h-[75vh] flex items-center">
      <div className="absolute top-8 lg:top-20  xl:top-8 -left-12 lg:left-0">
        <img
          ref={heroRef}
          src={HeroImg}
          alt="hero"
          className="relative object-cover opacity-0 z-0 w-full h-[65vh] lg:h-[73vh] 2xl:h-[80vh] rounded-r-[2rem] xl:rounded-r-[5rem]"
        />
      </div>

      <img
        src={BottomRight}
        alt="top right"
        className=" absolute -z-10 -bottom-32 2xl:-bottom-48 xl:block hidden opacity-70 left-[25%] 2xl:left-[30%] w-48 xl:w-72 2xl:w-96"
      />
      <div className="absolute hidden spin-circle xl:block top-12 xl:right-[15%] w-[30%]">
        <img src={Circle} alt="circle" />
      </div>
      <div className="absolute top-[90%] right-[15%] hidden rotate-[10deg] md:block">
        <DownView />
      </div>
      <div className="z-10 flex items-center w-11/12 lg:w-4/5 xl:w-4/5 mx-auto justify-between">
        <div className="max-w-3xl xl:max-w-4xl 2xl:max-w-5xl space-y-2">
          <h1
            ref={textRef}
            className="text-4xl opacity-0 sm:text-5xl xl:text-6xl hero-grad font-bold space-y-2 xl:space-y-4 text-white z-20 relative xl:leading-tight sm:leading-tight leading-tight"
          >
            {/* <span className="block">
              I Build <span className="">AI-powered interfaces</span>
            </span>
            <span className="block">
              <span className="hidden md:inline">and high-performance</span>
            </span>
            <span className="block">
              {" "}
              <span className="inline md:hidden">and high-performance</span>
              <span className="hidden md:inline">
                web apps using React & Next.js
              </span>
            </span>
            <span className="block">
              {" "}
              <span className="inline md:hidden">
                web apps using React & Next.js
              </span>
            </span> */}
            I Build AI-Powered interfaces and high-performance web apps using
            React & Next.js
          </h1>
          <div
            ref={workRef}
            className="w-full flex-col items-start space-y-4 flex"
          >
            <p className="text-white text-left w-11/12 sm:w-3/4 xl:w-3/5">
              Frontend engineer with over 4 years of experience building scalable,
              data-heavy and AI-driven applications used by thousands of users.
            </p>
            <div className="flex gap-4">
              <Button
                variant="primary"
                onClick={() => navigate("/contact")}
                custom="w-max py-2"
              >
                contact me
              </Button>
              <a
                href="https://eyobelkirub.dev/resume.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button variant="outline" custom="w-max py-2">
                  Resume
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
